import React, { useMemo, useState } from 'react';
import '../styles/Modelos.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faArrowLeft,
    faChevronLeft,
    faChevronRight,
    faFileLines,
    faFolderOpen,
    faMagnifyingGlass,
    faTag,
    faXmark
} from '@fortawesome/free-solid-svg-icons';
import PDFViewer from '../components/PDFViewer/PDFViewer';
import bgShapes from '../assets/BG-shapes-1.png';

const pdfs = [
    { id: 1, name: 'Ação de Reintegração Autarquia', tipo: 'Direito Administrativo', area: 'Administração Pública', path: '/modelos/acao-de-reintegracao-autarquia.pdf' },
    { id: 2, name: 'Admissão Temporária', tipo: 'Trabalho', area: 'Direito do Trabalho', path: '/modelos/admissao-temporaria.pdf' },
    { id: 3, name: 'Aposentadoria por Idade', tipo: 'Previdência', area: 'Direito Previdenciário', path: '/modelos/aposentadoria-por-idade.pdf' },
    { id: 4, name: 'Concessão Benefício Assistencial', tipo: 'Assistência Social', area: 'Direito Assistencial', path: '/modelos/concecao-beneficio-assistencial.pdf' },
    { id: 5, name: 'Contrato de Cessão de Crédito', tipo: 'Financeiro', area: 'Direito Contratual', path: '/modelos/contrato-de-cessao-de-credito.pdf' },
    { id: 6, name: 'Direito de Família Requerimento Adoção', tipo: 'Direito de Família', area: 'Adoção', path: '/modelos/direito-de-familia-requerimento-adocao.pdf' },
    { id: 7, name: 'Direito de Família União Estável', tipo: 'Direito de Família', area: 'União Estável', path: '/modelos/direito-de-familia-uniao-estavel.pdf' },
    { id: 8, name: 'Medida Cautelar de Sustação de Protesto de Duplicata', tipo: 'Judicial', area: 'Direito Civil', path: '/modelos/medida-cautelar-de-sustacao-de-protesto-de-duplicata.pdf' },
    { id: 9, name: 'Tomada de Preço', tipo: 'Licitação', area: 'Direito Administrativo', path: '/modelos/tomada-de-preco.pdf' },
    { id: 10, name: 'Tomada de Preço', tipo: 'Licitação', area: 'Direito Administrativo', path: '/modelos/tomada-de-preco.pdf' },
    { id: 11, name: 'Tomada de Preço', tipo: 'Licitação', area: 'Direito Administrativo', path: '/modelos/tomada-de-preco.pdf' },
    { id: 12, name: 'Tomada de Preço', tipo: 'Licitação', area: 'Direito Administrativo', path: '/modelos/tomada-de-preco.pdf' },
    { id: 13, name: 'Tomada de Preço', tipo: 'Licitação', area: 'Direito Administrativo', path: '/modelos/tomada-de-preco.pdf' }
];

const normalizeText = (text) =>
    text
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '');

const Modelos = () => {
    const [selectedPDF, setSelectedPDF] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');
    const [activeArea, setActiveArea] = useState('Todos');
    const [currentPage, setCurrentPage] = useState(1);
    const pdfsPerPage = 6;

    const areas = useMemo(() => ['Todos', ...new Set(pdfs.map((pdf) => pdf.area))], []);

    const filteredPdfs = useMemo(() => {
        const query = normalizeText(searchTerm);

        return pdfs.filter((pdf) => {
            const matchesSearch = [pdf.name, pdf.tipo, pdf.area]
                .some((value) => normalizeText(value).includes(query));
            const matchesArea = activeArea === 'Todos' || pdf.area === activeArea;

            return matchesSearch && matchesArea;
        });
    }, [activeArea, searchTerm]);

    const totalPages = Math.max(1, Math.ceil(filteredPdfs.length / pdfsPerPage));
    const indexOfLastPdf = currentPage * pdfsPerPage;
    const indexOfFirstPdf = indexOfLastPdf - pdfsPerPage;
    const currentPdfs = filteredPdfs.slice(indexOfFirstPdf, indexOfLastPdf);
    const selectedPdfName = pdfs.find((pdf) => pdf.path === selectedPDF)?.name || 'Modelo selecionado';

    const handleSearchChange = (event) => {
        setSearchTerm(event.target.value);
        setCurrentPage(1);
    };

    const handleAreaChange = (area) => {
        setActiveArea(area);
        setCurrentPage(1);
    };

    const clearSearch = () => {
        setSearchTerm('');
        setCurrentPage(1);
    };

    const handlePageChange = (pageNumber) => {
        setCurrentPage(Math.min(Math.max(pageNumber, 1), totalPages));
    };

    return (
        <div className='main-container-modelos'>
            <img className='bgshapes' src={bgShapes} alt='' aria-hidden='true' />

            <section className='container-modelos'>
                {selectedPDF ? (
                    <>
                        <div className='modelos-viewer-header'>
                            <button className='btn-voltar-modelos' onClick={() => setSelectedPDF(null)}>
                                <FontAwesomeIcon icon={faArrowLeft} />
                                <span>Voltar</span>
                            </button>

                            <div className='viewer-title-modelos'>
                                <FontAwesomeIcon icon={faFileLines} />
                                <span>{selectedPdfName}</span>
                            </div>
                        </div>

                        <div className='modelo modelo-viewer'>
                            <PDFViewer pdfPath={selectedPDF} />
                        </div>
                    </>
                ) : (
                    <>
                        <header className='modelos-hero'>
                            <div>
                                <p className='modelos-eyebrow'>Biblioteca jurídica</p>
                                <h1>Modelos de petições</h1>
                                <p className='modelos-subtitle'>
                                    Encontre, filtre e abra documentos prontos para consulta em poucos cliques.
                                </p>
                            </div>

                            <div className='modelos-summary'>
                                <strong>{pdfs.length}</strong>
                                <span>modelos disponíveis</span>
                            </div>
                        </header>

                        <div className='modelos-toolbar'>
                            <label className='container-input-pesquisa-modelos'>
                                <FontAwesomeIcon className='icone-pesquisa-modelos' icon={faMagnifyingGlass} />
                                <input
                                    className='input-pesquisa-modelos'
                                    value={searchTerm}
                                    onChange={handleSearchChange}
                                    placeholder='Pesquisar por modelo, tipo ou área'
                                />
                                {searchTerm && (
                                    <button className='icone-apagar-pesquisa' onClick={clearSearch} type='button' aria-label='Limpar pesquisa'>
                                        <FontAwesomeIcon icon={faXmark} />
                                    </button>
                                )}
                            </label>

                            <div className='modelos-filter-row' aria-label='Filtrar por área'>
                                {areas.map((area) => (
                                    <button
                                        key={area}
                                        className={`modelos-filter ${activeArea === area ? 'active' : ''}`}
                                        onClick={() => handleAreaChange(area)}
                                        type='button'
                                    >
                                        {area}
                                    </button>
                                ))}
                            </div>
                        </div>

                        <div className='modelos-content-header'>
                            <span>{filteredPdfs.length} resultados</span>
                            <span>Página {currentPage} de {totalPages}</span>
                        </div>

                        <div className='modelo'>
                            {currentPdfs.length > 0 ? (
                                <ul className='lista-pdfs'>
                                    {currentPdfs.map((pdf) => (
                                        <li key={pdf.id}>
                                            <button className='modelo-card' onClick={() => setSelectedPDF(pdf.path)} type='button'>
                                                <span className='modelo-card-icon'>
                                                    <FontAwesomeIcon icon={faFileLines} />
                                                </span>

                                                <span className='modelo-card-body'>
                                                    <strong>{pdf.name}</strong>
                                                    <span className='modelo-card-meta'>
                                                        <span>
                                                            <FontAwesomeIcon icon={faTag} />
                                                            {pdf.tipo}
                                                        </span>
                                                        <span>
                                                            <FontAwesomeIcon icon={faFolderOpen} />
                                                            {pdf.area}
                                                        </span>
                                                    </span>
                                                </span>
                                            </button>
                                        </li>
                                    ))}
                                </ul>
                            ) : (
                                <div className='modelos-empty'>
                                    <FontAwesomeIcon icon={faFileLines} />
                                    <strong>Nenhum modelo encontrado</strong>
                                    <span>Ajuste a pesquisa ou escolha outra área.</span>
                                </div>
                            )}
                        </div>

                        {totalPages > 1 && (
                            <div className='pagination'>
                                <button
                                    className='page-button page-arrow'
                                    onClick={() => handlePageChange(currentPage - 1)}
                                    disabled={currentPage === 1}
                                    type='button'
                                    aria-label='Página anterior'
                                >
                                    <FontAwesomeIcon icon={faChevronLeft} />
                                </button>
                                {[...Array(totalPages).keys()].map((number) => (
                                    <button
                                        key={number + 1}
                                        className={`page-button ${currentPage === number + 1 ? 'active' : ''}`}
                                        onClick={() => handlePageChange(number + 1)}
                                        type='button'
                                    >
                                        {number + 1}
                                    </button>
                                ))}
                                <button
                                    className='page-button page-arrow'
                                    onClick={() => handlePageChange(currentPage + 1)}
                                    disabled={currentPage === totalPages}
                                    type='button'
                                    aria-label='Próxima página'
                                >
                                    <FontAwesomeIcon icon={faChevronRight} />
                                </button>
                            </div>
                        )}
                    </>
                )}
            </section>
        </div>
    );
};

export default Modelos;
